import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import { cleanCollisions, continuousExtentParts } from '../chart_helpers/AxisHelper'
import MirrorAxisHelper from '../chart_helpers/MirrorAxisHelper'
import SizeHelper from '../chart_helpers/SizeHelper'
import { categoricalExtent, continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import { dentedRect } from '../utils/pathUtils'
import { scaleBand as d3_scaleBand } from 'd3-scale'

const MAX_BAR_WIDTH = 40
export default class PyramidChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = true
  }
  static defaultConfig = {
    /**
     * Orientation of the bars. When setting `horizontal: true` the x and y axes will be swapped.
     */
    horizontal: {
      type: Boolean,
      default: true,
      exposed: true,
      nonEditable: true,
    },
    mode: {
      type: Boolean,
      default: true,
      exposed: true,
      nonEditable: true,
    },
    dataSorting: {
      type: [String],
      default: 'none',
      options: ['none', 'asc', 'desc'],
      exposed: true,
    },
    /**
     * Show the value on top of each bar.
     */
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
      nonEditable: true,
    },
    /**
     * Minimum height of each bar (in pixels).
     */
    minBarHeight: {
      type: [Number],
      default: 0,
      exposed: true,
    },
    AxisHelper: {
      /**
       * Enable automatic scroll. If enabled, axes will be scrolalbel only if the number of bars is large enough.
       */
      zoom: {
        value: false,
      },
      x: {
        dimensions: 'male-and-female',
        scale: {
          value: 'band',
          exposed: false,
        },
        getExtent: function (data) {
          return categoricalExtent([...data.male, ...data.female])
        },
        showTickValues: {
          nonEditable: true,
        },
        tickOrientation: {
          nonEditable: true,
        },
      },
      y: {
        side: 'left',
        getExtent: function (data) {
          let extent, extentParts

          extentParts = continuousExtentParts([...data.male, ...data.female], d => [d.y0, d.y1])
          // console.log("extent parts",extentParts)
          extent = continuousExtent(extentParts)

          //Protect label!
          // let originalExtent = extent

          // extent = padLinear(extent,0.2)

          // NOT GOOD, porque se hace el padlinear luego, en el _setDomain
          // if(originalExtent[0]>=0) extent[0]=0
          // console.log("bar extent bef",extent)
          if (this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit) {
            extent = cleanCollisions(this.axes.y_0, extent, extentParts)
          }
          // console.log("bar extent aft",extent)
          return extent
        },
      },
    },
    TooltipBehavior: {
      itemsKeys: ['maleItems', 'femaleItems'],
      getItemOffset: function ($el) {
        let original = $el.getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5
        }
      },
      getHtml: function (d, itemsKey) {
        console.log('should use onAxis', itemsKey)
        let onAxis = itemsKey === 'maleItems' ? 'y_0' : 'y_1'
        if (itemsKey === 'maleItems') {
          return `
            <div class="tip-value important">${this.valueWithUnit(d.value, onAxis)}</div>
            <div class="tip-id">
              <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
                { id: d.parentId },
                0
              )}; margin-right: 3px"></span>
              ${d.parentId}
            </div>
            <div class="secondary">${this.formatValue(d.id, 'x')}</div>
            `
        } else {
          return `
            <div class="tip-value important">${this.valueWithUnit(d.value, onAxis)}</div>
            <div class="tip-id">
              <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
                { id: d.id },
                1
              )}; margin-right: 3px"></span>
              ${d.id}
            </div>
            `
        }

        /*return `
          <span class="important">${this.valueWithUnit(d.value, onAxis)}</span>
          <br/>
          ${d.id}
        `*/
      },
    },
  }
  static helpers = [RootHelper, ItemsHelper, SelectableHelper, SizeHelper, MirrorAxisHelper]
  checkConsistency() {
    return true
  }
  draw() {
    let longDir, getTranslate, getOffset, getShort //,shortDir

    let barWidth, subBarWidth

    longDir = 'height'
    // shortDir = 'width'
    getTranslate = (long, short) => {
      return `translate(${short},${long})`
    }

    let offsetValue
    if (this.axes.y_0.func.scale().domain()[0] < 0 && this.axes.y_0.func.scale().domain()[1] > 0)
      offsetValue = 0
    else offsetValue = this.axes.y_0.func.scale().domain()[0]

    // getOffset = v => Math.min(v, this.axes.y_0.func.scale()(offsetValue))
    // getOffset = v => {
    //   if (this.axes.y_0.func.scale().domain()[0] === 0)
    //     return Math.min(v, this.axes.y_0.func.scale()(offsetValue))
    //   else return this.axes.y_0.func.scale()(offsetValue)
    // }
    // getShort = v => Math.abs(this.axes.y_0.func.scale()(offsetValue) - v)
    getShort = (v, axis) => {
      let val = this.axes[axis].func.scale()(offsetValue) - v
      return Math.abs(val)
      // if (this.axes.y_0.func.scale().domain()[0] === 0 || val < 0) return Math.abs(val)
      // else return 1
    }

    let barPercent = 0.7
    barWidth = Math.min(MAX_BAR_WIDTH, this.axes.x.scale.bandwidth() * barPercent)
    let barMargin = (this.axes.x.scale.bandwidth() - barWidth) / 2

    let drawItem

    let stackPadding = 2
    drawItem = (sel, axis, status) => {
      sel.attr('transform', d => {
        let barPos
        if (status === 'enter' || status === 'exit') barPos = this.axes[axis].func.scale()(0)
        else barPos = this.axes[axis].func.scale()(axis === 'y_1' ? d.y0 : d.y1)
        return getTranslate(
          this.axes.x.func.scale()(d.id) + barMargin,
          barPos + (this.config.horizontal ? 0 : stackPadding / 2)
        )
      })

      sel
        .select('path')
        .attr('fill', d => this.color({ id: d.parentId }))
        .attr('d', d => {
          let barLength
          if (status === 'enter' || status === 'exit') barLength = 0
          else
            barLength =
              getShort(this.axes[axis].func.scale()(d.safeValue), axis) -
              (d.isFirstLayer ? stackPadding : stackPadding) //no tenia sentido hacerlos distinos, no!?

          barLength = Math.max(barLength, 0) //y le faltaba esto para cuando el "safeValue" da 0!!!
          let w = longDir === 'width' ? barWidth : barLength
          let h = longDir === 'width' ? barLength : barWidth
          return dentedRect(
            w,
            h,
            d.isLastLayer
              ? longDir === 'width'
                ? 'tl'
                : 'tr'
              : d.isFirstLayer
              ? longDir === 'width'
                ? 'br'
                : 'bl'
              : 'none'
          )
        })
    }

    let types = ['male', 'female']
    types.forEach(type => {
      let axis = type === 'male' ? 'y_0' : 'y_1'
      this[type + 'ItemsEnter'].append('path')

      // HAy que pintar lo "viejos" primero para assegurar que se mantiene el orden de colores...
      this[type + 'ItemsTrans'].call(drawItem, axis)
      this[type + 'ItemsEnter'].call(drawItem, axis, 'enter')
      this[type + 'ItemsEnterTrans'].call(drawItem, axis)
      this[type + 'ItemsExitTrans'].style('opacity', 0)
      if (this[type + 'ParentItemsExitTrans'])
        this[type + 'ParentItemsExitTrans'].style('opacity', 0)
    })
  }
  getLegendData() {
    let legendData = [...this.data.male]
    legendData.icon = 'square'
    // legendData.__forceDraw__ = true
    return legendData
  }
}
